<template>
  <div class="route pl-1">
    <div v-if="!mobile" class="row d-flex justify-content-between align-items-center mt-3 pr-lg-3">
      <div class="col-lg-6 d-flex align-items-center">
        <PageTitle :titles="['Cadastrar', 'Rotas']" :hideCount="true" />
      </div>
    </div>

    <b-modal ref="removeRoute" centered size="sm" ok-variant="danger" cancel-variant="outline-secondary"
      @ok="confirmRemove" cancel-title="Cancelar" ok-title="Deletar" title="Atenção!">
      <div class="modal-form">
        <div class="title-modal-info">
          Serão deletados
          <span class="font-weight-bold">{{ selected.length }}</span>
          <span> {{ selected.length == 1 ? " rota. " : ` rotas.` }} </span>
        </div>
      </div>
    </b-modal>

    <b-modal centered ref="formRoutes" @cancel="resetPage" @ok="submit" hide-header size="sm" ok-variant="3v3"
      cancel-variant="outline-secondary" ok-title="Salvar" cancel-title="Fechar">
      <div class="form-header">
        <h5>{{ formTitle }}</h5>
      </div>

      <b-form @keyup.enter="submit">
        <b-form-text id="channelInputLiveHelp"> Destino * </b-form-text>
        <b-form-input v-model="form.ADDR" aria-describedby="channelInputLiveHelp channelInputLiveFeedback" type="number"
          :state="destState" :formatter="format" :min="1" :max="250">
        </b-form-input>
        <b-form-invalid-feedback v-show="hasAddrError" id="channelInputLiveFeedback">
          {{ addrMsgError }}
        </b-form-invalid-feedback>
        <b-form-text id="toutInputLiveHelp"> Origem * </b-form-text>
        <b-form-input v-model="form.NEIGHBOR" aria-describedby="toutInputLiveHelp toutInputLiveFeedback" type="number"
          :state="srcState" :formatter="format" :min="0" :max="250">
        </b-form-input>
        <b-form-invalid-feedback v-show="hasNeighborError" id="toutInputLiveFeedback">
          {{ neighborMsgError }}
        </b-form-invalid-feedback>
      </b-form>
    </b-modal>

    <div class="row container-routes">
      <div class="col right-container" v-if="!mobile">
        <div class="route-tree-title">
          <span class="font-weight-bold pl-3"> Rotas</span>
        </div>
        <div class="route-tree d-block">
          <route-tree :connections="monitoring" />
        </div>
      </div>
      <!-- col-xs-12 col-sm-4 -->
      <div class="col-xs-12 col-sm-4 left-container">
        <div class="route-tree-title">
          <span class="font-weight-bold pl-3">Tabela de rotas</span>
        </div>
        <div class="routes w-100 m-0 p-0">
          <b-table striped small hover responsive :items="routes" :fields="fields" thead-class="custom-header"
            class="custom-table m-0 p-0">
            <template slot="HEAD_CHECK">
              <b-form-checkbox @click.native.prevent="toggleAll()" v-show="isAdmin"
                v-model="allSelected"></b-form-checkbox>
            </template>
            <template slot="CHECK" slot-scope="row">
              <b-form-checkbox :value="row.item" v-model="selected"></b-form-checkbox>
            </template>

            <template slot="NEIGHBOR" slot-scope="row">
              {{ row.item.NEIGHBOR == 0 ? "CIR" : row.item.NEIGHBOR }}
            </template>
          </b-table>
        </div>
        <div class="wrapper-buttons d-flex justify-content-end flex-wrap">
          <b-btn v-if="mobile" type="button" class="route-tree-button route-btn btn text-center rounded-pill" size="sm"
            @click="showTree = true" variant="3v3">
            <source-branch-icon title="" />
          </b-btn>
          <b-btn type="button" class="route-btn btn text-center rounded-pill" title="Adicionar DIR" @click="addRoute()"
            v-if="isAdmin" size="sm" variant="3v3">
            <plus-icon title="" />
          </b-btn>
          <b-btn type="button" title="Deletar DIR" class="route-btn btn text-center rounded-pill"
            :disabled="!isAdmin" @click="routeDelete()" size="sm" variant="danger">
            <delete-icon title="" />
          </b-btn>
          <b-btn type="button" title="Editar DIR" class="route-btn btn text-center rounded-pill"
            :disabled="!isAdmin || selected.length != 1" @click="routeEdit()" size="sm" variant="info">
            <pencil-icon title="" />
          </b-btn>
          <b-btn type="button" title="Sincronizar DIR" class="route-btn btn text-center rounded-pill" @click="routeSync()"
            :disabled="!isAdmin || selected.length != 1" size="sm" variant="3v3">
            <sync-icon title="Sincronizar" />
          </b-btn>
          <b-btn type="button" title="Resetar DIR" class="route-btn btn text-center rounded-pill" @click="dirReset()"
            :disabled="!isAdmin || selected.length != 1" size="sm" variant="3v3">
            <backup-restore-icon :title="`Resetar DIR ${(selected[0] && selected[0].ADDR) || ''}`" />
          </b-btn>
        </div>
      </div>

      <!-- col-xs-8 -->
    </div>

    <div class="legend" v-if="!mobile">
      <div class="legend-item d-flex align-items-center">
        <span class="green legend-color"></span>
        <span class="">Comunicando</span>
      </div>
      <div class="legend-item d-flex align-items-center">
        <span class="yellow legend-color"></span>
        <span class="">Timeout</span>
      </div>
      <div class="legend-item d-flex align-items-center">
        <span class="red legend-color"></span>
        <span class="">Sem comunicação.</span>
      </div>
      <div class="legend-item d-flex align-items-center">
        <span class="grey legend-color"></span>
        <span class="">Não cadastrado</span>
      </div>
      <div class="legend-item d-flex align-items-center">
        <span class="black legend-color"></span>
        <span class="">Dispositivo de Origem com FALHA.</span>
      </div>
    </div>

    <div v-if="mobile && showTree">
      <div id="overlay" @click="showTree = false"></div>
      <div id="details">
        <div class="row content col-xs-12 route-tree-complete   justify-content-center">
          <div class="w-90 d-flex flex-column route-tree-body">
            <div class="route-tree-title">
              <span class="font-weight-bold pl-3"> Rotas</span>
            </div>
            <div class="route-tree">
              <route-tree :connections="monitoring" />
            </div>
          </div>
          <div class="legend">
            <div class="legend-item d-flex align-items-center">
              <span class="green legend-color"></span>
              <span class="">Comunicando</span>
            </div>
            <div class="legend-item d-flex align-items-center">
              <span class="yellow legend-color"></span>
              <span class="">Timeout</span>
            </div>
            <div class="legend-item d-flex align-items-center">
              <span class="black legend-color"></span>
              <span class="">Dispositivo de Origem com FALHA.</span>
            </div>
            <div class="legend-item d-flex align-items-center">
              <span class="red legend-color"></span>
              <span class="">Sem comunicação.</span>
            </div>
            <div class="legend-item d-flex align-items-center">
              <span class="grey legend-color"></span>
              <span class="">Não cadastrado</span>
            </div>
          </div>
        </div>
        <footer id="footer">
          <b-btn class="close-btn" size="sm" block @click="showTree = false"> Fechar </b-btn>
        </footer>
      </div>
    </div>
  </div>
</template>

<script>
import { routes, cmd } from "@/api";
import { cookies } from "@/pages/components/cookies";
import PageTitle from "@/pages/temps/components/PageTitle.vue";

export default {
  components: {
    PageTitle,
  },
  name: "route",
  props: {
    mobile: Boolean,
  },
  created() {
    this.$emit("title-change", "Roteamento");
    this.controller = new AbortController();
    this.loadRoutesPerAddr();
    this.monitRoutes();
    this.isAdmin = Number(cookies.get("PERMISSION")) == 1;
  },
  data() {
    return {
      
      showTree: false,
      isAdmin: false,
      controller: null,
      timeout: null,
      monitoring: [],
      hasAddrError: false,
      hasNeighborError: false,
      addrMsgError: "",
      neighborMsgError: "",
      formTitle: "",
      errFwRes: 0,
      selected: [],
      allSelected: false,
      fields: [
        {
          key: "CHECK",
        },
        {
          key: "ADDR",
          label: "Destino",
        },
        {
          key: "NEIGHBOR",
          label: "Origem",
        },
      ],
      routes: [],
      form: {
        ADDR: 1,
        NEIGHBOR: 0,
      },
    };
  },
  beforeDestroy() {
    this.controller.abort();
    clearTimeout(this.timeout);
  },
  watch: {
    selected() {
      this.allSelected =
        this.selected.length && this.routes.length == this.selected.length;
    },
    routes() {
      this.allSelected =
        this.selected.length && this.routes.length == this.selected.length;
    },
  },
  computed: {
    destState() {
      if (this.form.ADDR == 0) {
        this.addrMsgError = "Não pode ser igual a zero";
        this.hasAddrError = true;
        return false;
      } else if (this.form.ADDR == this.form.NEIGHBOR) {
        this.addrMsgError = "Deve ser diferente do vizinho";
        this.hasAddrError = true;
        return false;
      } else if (this.form.ADDR > 250) {
        this.addrMsgError = "Não pode ser maior que 250";
        this.hasAddrError = true;
        return false;
      } else if (this.checkIfLoopExists()) {
        this.addrMsgError =
          "Rota em loop, pois estes equipamentos comunicam entre si";
        this.neighborMsgError = "Rota em loop";
        this.hasAddrError = true;
        this.hasNeighborError = true;
        return false;
      } else if (this.form.ADDR > 0) {
        this.hasAddrError = false;
        return true;
      }
    },
    srcState() {
      let origins = this.routes.map((e) => e.ADDR);
      let hasOrigin = origins.some((e) => e == this.form.NEIGHBOR);
      if (this.form.ADDR == this.form.NEIGHBOR) {
        this.neighborMsgError = "Deve ser diferente do vizinho";
        this.hasNeighborError = true;
        return false;
      } else if (this.form.NEIGHBOR > 250) {
        this.neighborMsgError = "Não pode ser maior que 250";
        this.hasNeighborError = true;
        return false;
      } else if (this.checkIfLoopExists()) {
        this.addrMsgError =
          "Rota em loop, pois estes equipamentos comunicam entre si";
        this.neighborMsgError = "Rota em loop";
        this.hasAddrError = true;
        this.hasNeighborError = true;
        return false;
      } else if (this.form.NEIGHBOR != 0 && !hasOrigin) {
        this.neighborMsgError = "A origem não existe";
        this.hasNeighborError = true;
        return false;
      } else if (this.form.NEIGHBOR >= 0) {
        this.hasNeighborError = false;
        return true;
      }
    },
  },
  methods: {
    checkIfLoopExists() {
      let len = this.routes.length;
      for (let i = 0; i < len; i++) {
        if (this.form.ADDR == this.routes[i].NEIGHBOR) {
          if (this.form.NEIGHBOR == this.routes[i].ADDR) return true;
        }
      }
      return false;
    },
    format(value) {
      return Number(value);
    },
    toggleAll() {
      this.allSelected = !this.allSelected;
      if (this.selected.length < this.routes.length)
        this.selected = this.routes.slice();
      else if (this.selected.length == this.routes.length) this.selected = [];
    },
    loadRoutesPerAddr() {
      routes
        .listPerAddr()
        .then((ret) => {
          this.routes = ret;
        })
        .catch((err) => {
          console.log(err);
          alert("Erro ao carregar rotas.");
        });
    },
    monitRoutes() {
      // responsável pela árvore
      routes
        .monitRoutes(this.controller)
        .then((ret) => {
          this.setBG(ret);
          return;
        })
        .catch((err) => {
          console.log(err);
          return err.name;
        })
        .then((ret) => {
          if (ret !== "AbortError") {
            this.timeout = setTimeout(this.monitRoutes, 5000);
          }
        });
    },
    confirmRemove() {
      routes
        .del(this.selected)
        .then((ret) => {
          alert(ret.log, ret.alert);
          this.resetPage();
        })
        .catch((err) => {
          console.log(err);
          alert(
            "Ocorreu um erro ao tentar excluir a(s) rota(s) selecionada(s)."
          );
        });
    },
    addRoute() {
      this.formTitle = "Adicionar rota";
      this.resetPage();
      this.$refs.formRoutes.show();
    },
    routeDelete() {
      this.$refs.removeRoute.show();
    },
    routeEdit() {
      this.formTitle = "Editar rota";
      this.form.ID = this.selected[0].ID;
      this.form.ADDR = this.selected[0].ADDR;
      this.form.NEIGHBOR = this.selected[0].NEIGHBOR;
      this.$refs.formRoutes.show();
    },
    submit(e) {
      if (this.srcState && this.destState) {
        if (this.form.ID) {
          routes
            .edit(this.form)
            .then((ret) => {
              alert(ret.log, ret.alert);
              this.resetPage();
              this.loadRoutesPerAddr();
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          routes
            .add(this.form)
            .then((ret) => {
              alert(ret.log, ret.alert);
              this.resetPage();
              this.loadRoutesPerAddr();
            })
            .catch((err) => {
              console.log(err);
            });
        }
        this.$refs.formRoutes.hide();
      } else e.preventDefault();
    },
    async dirReset() {
      try {
        
          wait.show();
          let ID = this.selected[0].ID;
          let ITEM = this.selected[0].ADDR;
          let CMD = "DIR_RST";
          if (ITEM < 10) ITEM = `00${ITEM}`;
          else if (ITEM < 100) ITEM = `0${ITEM}`;
          let data = { ITEM, CMD };
          this.errFwRes = 0;
          let ret = await cmd.reqfw(data);
          this.canExecuteRestart = false;
          // this.getResponseFirmware(1000, ret.value);
          alert(ret.log, ret.alert);
          wait.hide();
        
        

      } catch (err) {
        console.log(err);
      } finally {
       
      }
    },

    async routeSync() {

      let data = this.selected[0];

      // this.showWaitDialog();

      try {
          this.canExecuteSync = false;
          wait.show();
          let ret = await cmd.dirsyncroute(data);
          // this.getResponseFirmware(1000, ret.value);
          alert(ret.log, ret.alert);
          wait.hide();
         
        

      } catch (error) {
        wait.hide();
        console.log(error);
      }
    },
    resetPage() {
      this.selected = [];
      this.form = {
        ADDR: 1,
        NEIGHBOR: 0,
      };
      this.loadRoutesPerAddr();
    },
    setBG(list) {
      let success = "3v3";
      let timeout = "yellow";
      let fault1 = "red";
      let fault2 = "black";
      let unknown = "grey";
      this.monitoring = list.map((e) => {
        if (e.STATUS == 0) e.bg = success;
        else if (e.STATUS == 7) e.bg = timeout;
        else if (e.STATUS == 8) e.bg = fault1;
        else if (e.STATUS == 9) e.bg = fault2;
        else e.bg = unknown;
        return e;
      });
    },
  },
};
</script>

<style scoped>
#overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  z-index: 999;
}

#details {
  position: fixed;
  top: var(--size-bars);
  right: 0;
  width: 90vw;
  height: calc(100vh - var(--size-bars));
  overflow: hidden;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  padding-top: 15px;
  background-color: var(--background-white);
}

#details .route-tree-complete {
  flex: 1;
  min-height: 0;
  width: 100%;
  padding: 20px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

#details .route-tree-body {
  flex: 1;
  min-height: 0;
  max-height: 65vh;
}

#details #footer {
  flex-shrink: 0;
  background-color: var(--background-white);
  display: flex;
  align-items: center;
  padding: 8px 20px;
  padding-bottom: max(env(safe-area-inset-bottom, 0px), 16px);
}

.route {
  height: 85vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.routes,
.route-tree {
  background: #ffffff;
  border-radius: 4px;
  overflow: auto;
}

.route-tree {
  flex: 1;
  min-height: 0;
  border: 2px solid var(--orange-color);
  padding-left: 5px;
  border-radius: 0px 0px 4px 4px;
}

.route-tree-title {
  width: 100%;
  color: #ffffff;
  background-color: var(--orange-color);
  border-radius: 4px 4px 0px 0px;
}

.legend {
  display: flex;
  flex-wrap: wrap;
  flex-shrink: 0;
  padding: 5px 0 2px;
  border-top: 1px solid #e0e0e0;
}

.legend-color {
  width: 20px;
  height: 20px;
  border-radius: 20px;
  margin-right: 5px;
}

.legend-item {
  font-size: 0.8rem;
  margin-top: 4px;
  flex-basis: 20%;
  margin-bottom: 4px;
}

.green {
  background: #3d9161;
}

.yellow {
  background-color: #edad49;
}

.black {
  background-color: #494949;
}

.grey {
  background-color: #949597;
}

.red {
  background-color: var(--red-color-secondary);
}

.custom-table /deep/ .custom-header {
  position: sticky;
  top: 0;
  z-index: 1;
  box-sizing: border-box;
  color: #ffffff;
  background-color: var(--orange-color);
}

.custom-table /deep/ .custom-header tr th {
  position: sticky;
  top: 0;
  z-index: 1;

}

.routes {
  border: 2px solid var(--orange-color);
  border-top: 0px;
  flex: 1;
  min-height: 0;
}

.container-routes {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  align-items: stretch;
  flex-wrap: nowrap;
}

.right-container {
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.left-container {
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

.route-tree-button {
  display: none;
}

.wrapper-buttons {
  flex-shrink: 0;
  padding: 6px 4px 2px;
  gap: 4px;
}

.route-btn {
  --size-action-button: 37.6px;
  height: var(--size-action-button);
  width: var(--size-action-button);
  padding: 0;
}

.route-btn,
.route-btn * {
  font-size: 1rem !important;
  display: flex;
  align-items: center;
  justify-content: center;
}


@media (max-width: 1600px) {
  .legend-item {
    flex-basis: calc(25% - 10px);
  }
}

@media (max-width: 1160px) {
  .legend-item {
    flex-basis: calc(33% - 10px);
  }
}

@media (max-width: 890px) {
  .legend-item {
    flex-basis: calc(50% - 10px);
  }
}

@media (max-width: 767px) {
  .route-tree-complete {
    width: 100%;
  }

  .route-tree-body {
    width: 100%;
  }

}

@media screen and (max-width: 789px) {
  .container-routes {
    padding: 0 4px;
  }

  .routes,
  .route-tree {
    box-shadow: none;
  }

  .container {
    height: 100%;
    padding: 0;
  }

  .route {
    padding-top: calc(var(--size-bars) + 5px);
    height: calc(100dvh - var(--size-bars) - var(--side-nav-icon-height));
  }

  /* Altura explícita garante que os filhos flex (tabela + botões) sejam
     corretamente contidos, sem depender da herança de altura do Bootstrap row */
  .left-container {
    height: calc(100dvh - var(--size-bars) - var(--side-nav-icon-height) - (var(--size-bars) + 5px));
  }

  .routes {
    max-height: calc(100dvh - var(--size-bars) - var(--side-nav-icon-height) - (var(--size-bars) + 5px) - 80px);
  }

  .route-tree-button {
    display: flex;
  }
}

@media screen and (max-width: 430px) {
  #details {
    width: 100vw;
    overflow-y: auto;
  }

  .route {
    padding-top: calc(var(--size-bars) + 5px);
  }

  .legend-item {
    flex-basis: 100%;
  }

  #details .route-tree-complete {
    padding: 10px;
  }

  .legend {
    padding-bottom: calc(var(--side-nav-icon-height) + 8vh + 30px)
  }
}
</style>
